
/* eslint-disable vue/no-mutating-props */
// `target` is the orchestrator's person object (logic.js newPerson()), passed
// by reference so the four answers land directly on it — same pattern as the
// V2 wizard's SoaStep.
import { COPY } from './copy'

export default {
    props: {
        target: { type: Object, required: true },
    },
    data () {
        return { COPY }
    },
    methods: {
        set (key, val) {
            this.$set(this.target, key, val)
        },
    },
}
